import { Component, DoCheck, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SafeUrlPipe } from '../pipes/safe-url-pipe';
import { MatIconModule } from '@angular/material/icon';
import { CalendlyService } from '../services/calendly-service'
import { DialogData, TopicGroup, TopicOption, WebhookMonitorResponse } from '../interfaces/calendely.interface';

@Component({
  selector: 'app-calendly-topic-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatButtonModule,
    MatDividerModule,
    MatToolbarModule,
    MatDialogModule,
    MatIconModule,
    SafeUrlPipe
  ],
  templateUrl: './calendly-topic-dialog.component.html',
  styleUrls: ['./calendly-topic-dialog.component.scss'],
})
export class CalendlyTopicDialogComponent implements DoCheck, OnInit  {

  topics: TopicGroup[] = [];
  step = 1;
  selectedTopic: string | null = null; 
  selectedSubtopic: TopicOption | null = null;
  errorMsg = '';
  dialogRef = inject(MatDialogRef<CalendlyTopicDialogComponent>);
  data = inject<DialogData>(MAT_DIALOG_DATA, { optional: true });
  calendlyService = inject(CalendlyService);

  ngDoCheck() {
    if (this.step === 3) {
      this.dialogRef.addPanelClass('fullscreen-dialog');
    } else {
      this.dialogRef.removePanelClass('fullscreen-dialog');
    }
  }

  ngOnInit() {
      this.topics = this.data?.topicSubtopics ?? [];
  }

  submitTopic() {
    this.errorMsg = '';
    if (!this.selectedTopic) {
      this.errorMsg = "Please select a topic to continue.";
      return;
    }
    const selectedGroup = this.topics.find(t => t.title === this.selectedTopic);
    const subtopics = selectedGroup ? selectedGroup.value : [];
    if (subtopics.length === 1) {
      this.selectedSubtopic = subtopics[0];
      this.validateWebhook(this.data?.userDetails.brandName);
    } else {
      this.step = 2;
      this.selectedSubtopic = null;
    }
  }

  submitSubtopic() {
    this.errorMsg = '';
    if (!this.selectedSubtopic) {
      this.errorMsg = "Please select a subtopic to continue.";
      return;
    }
    if (this.selectedSubtopic) {
      this.validateWebhook(this.data?.userDetails.brandName);
    }
  }
  
  validateWebhook(brandName?: string) {
    console.log(brandName);
    if (!brandName) {
      this.errorMsg = 'Brand name is required to validate webhook.';
      return;
    }
    this.calendlyService.validateWebhook(brandName).subscribe({
      next: (res: WebhookMonitorResponse) => {
        if (res.success) {
          this.step = 3;
        } else {
          this.errorMsg = "Calendly Webhook validation failed. please try after some time.";
        }
      },
      error: () => {
        this.errorMsg = "Server error while validating webhook.";
      }
    });
  }

  getSubtopicsForselectedTopic() {
    const selectedGroup = this.topics.find(t => t.title === this.selectedTopic);
    return selectedGroup ? selectedGroup.value : [];
  }

  getCalendlyUrl(): string {
    const baseUrl = this.selectedSubtopic?.scheduling_url;
    if (!baseUrl) return '';
    
    const params = new URLSearchParams({
       utm_campaign: this.selectedSubtopic?.value ?? '', // it should be
      utm_content: this.selectedSubtopic?.topic_name ?? '',
      utm_source: this.data?.userDetails.brandName ?? '',
      name: this.data?.userDetails?.agentName ?? '',
      email: this.data?.userDetails?.agentEmail ?? '',
      a1: this.data?.userDetails?.primaryPhoneNumber ?? '',
      a2: this.data?.userDetails?.companyName ?? '',
      a3: (((this.data?.userDetails?.city ?? '') + ' ' + (this.data?.userDetails?.state ?? '')).trim()) ?? '',
      a4: this.data?.userDetails?.companyID ?? '',
    });
    console.log(`${baseUrl}?${params.toString()}`);
    return `${baseUrl}?${params.toString()}`;
  }

}
